(function (module) {
    "use strict";

    module.service('brandCalculationService', ['synchronousEventsBus', 'forecastCacheService', 'mkrshCalculatorService',
        function(
            this: $TSFixMe,
            synchronousEventsBus: $TSFixMe,
            forecastCacheService: $TSFixMe,
            mkrshCalculatorService: $TSFixMe
        ) {
            var service = this;

            service.registerEvents = function () {
                synchronousEventsBus.$on('pmForecastChanged', function (e: $TSFixMe, args: $TSFixMe) {

                    
                    if(!_.contains(['sku', 'mktsh'], args.parameters.forecastMethod.methodId)){
                        return;
                    }
                        
                    var forecast = forecastCacheService.getForecast();
                    if ((forecast.parameters.forecastType.typeId == 'volume' || args.parameters.forecastType.typeId == 'dot')
                        && forecast.parameters.forecastMethod.methodId == 'mktsh') {

                        angular.forEach(forecast.market.brands, function (brand: $TSFixMe) {
                            return service.brandMkshrChanged(brand, forecast.parameters);
                        });
                    }
                });

                synchronousEventsBus.$on('value.pmForecastChanged', function (e: $TSFixMe, args: $TSFixMe) {
                    var forecast = forecastCacheService.getForecast();
                    if (forecast.parameters.forecastType.typeId == 'value' && forecast.parameters.forecastMethod.methodId == 'mktsh') {

                        angular.forEach(forecast.market.brands, function (brand: $TSFixMe) {
                            return service.brandMkshrChanged(brand, forecast.parameters);
                        });
                    }
                });

                synchronousEventsBus.$on('skuValueForecastChanged', function (e: $TSFixMe, args: $TSFixMe) {
                    if ((args.parameters.forecastType.typeId == 'volume' ||
                        args.parameters.forecastType.typeId == 'dot') && args.parameters.forecastMethod.methodId == 'mktsh') {
                        return service.calculateBrandValueTroughtSkus(args.brand, args.parameters);
                    }
                });

                synchronousEventsBus.$on('skuVolumeForecastChanged', function (e: $TSFixMe, args: $TSFixMe) {
                    if ((args.parameters.forecastType.typeId == 'value' || args.parameters.forecastType.typeId == 'dot') && args.parameters.forecastMethod.methodId == 'mktsh') {
                        return service.calculateBrandVolumeTroughtSkus(args.brand, args.parameters);
                    }
                });
            }

            service.brandMkshrChanged = function (brand: $TSFixMe, parameters: $TSFixMe) {
                var forecast = forecastCacheService.getForecast();

                if (parameters.forecastType.typeId == 'volume') {
                    return service.calculateBrandVolumeThroughtMkshr(forecast, brand);
                } else if (parameters.forecastType.typeId == 'value') {
                    return service.calculateBrandValueTroughtMkshr(forecast, brand);
                } else if (parameters.forecastType.typeId = 'dot') {
                    return service.calculateBrandDotThroughtMkshr(forecast, brand);
                }
            }


            service.calculateBrandVolumeThroughtMkshr = function (forecast: $TSFixMe, brand: $TSFixMe) {

                if (angular.isUndefinedOrNull(brand.forecast) || angular.isUndefinedOrNull(brand.forecast.mkshr))
                    return;


                if (angular.isUndefinedOrNull(brand.forecast.volume)) {
                    brand.forecast.volume = {
                        pmForecast: [],
                        statisticalForecast: []
                    };
                }
                mkrshCalculatorService.multiplieByMksrh(brand.forecast.mkshr,
                    forecast.market.forecast.pmForecast,
                    forecast.market.forecast.statisticalForecast,
                    brand.forecast.volume.pmForecast,
                    brand.forecast.volume.statisticalForecast);

                return synchronousEventsBus.$broadcast('brandVolumeForecastChanged', { forecast: forecast, brand: brand });
            }

            service.calculateBrandDotThroughtMkshr = function (forecast: $TSFixMe, brand: $TSFixMe) {

                if (angular.isUndefinedOrNull(brand.forecast) || angular.isUndefinedOrNull(brand.forecast.mkshr))
                    return;


                if (angular.isUndefinedOrNull(brand.forecast.dot)) {
                    brand.forecast.dot = {
                        pmForecast: [],
                        statisticalForecast: []
                    };
                }

                mkrshCalculatorService.multiplieByMksrh(brand.forecast.mkshr,
                    forecast.market.forecast.pmForecast,
                    forecast.market.forecast.statisticalForecast,
                    brand.forecast.dot.pmForecast,
                    brand.forecast.dot.statisticalForecast);

                return synchronousEventsBus.$broadcast('brandDotForecastChanged', { forecast: forecast, brand: brand });
            }

            service.calculateBrandValueTroughtMkshr = function (forecast: $TSFixMe, brand: $TSFixMe) {

                if (angular.isUndefinedOrNull(brand.forecast) || angular.isUndefinedOrNull(brand.forecast.mkshr))
                    return;


                if (angular.isUndefinedOrNull(brand.forecast.value)) {
                    brand.forecast.value = {
                        pmForecast: [],
                        statisticalForecast: []
                    };
                }

                mkrshCalculatorService.multiplieByMksrh(brand.forecast.mkshr,
                    forecast.market.forecast.value.pmForecast,
                    forecast.market.forecast.value.statisticalForecast,
                    brand.forecast.value.pmForecast,
                    brand.forecast.value.statisticalForecast);
                return synchronousEventsBus.$broadcast('brandValueForecastChanged', { forecast: forecast, brand: brand });
            }

            service.calculateBrandValueTroughtSkus = function (brand: $TSFixMe, parameters: $TSFixMe) {
                
                var s = _.find(brand.skus, function (sku: $TSFixMe) {

                    return !angular.isUndefinedOrNull(sku.forecast.value.statisticalForecast);
                });

                brand.forecast.value = {
                    pmForecast: [],
                    statisticalForecast: []
                };

                for (var i = 0; i < s.forecast.value.statisticalForecast.length; i++) {

                    var pmForecastSum = 0;
                    var statisticalForecastSum = 0;
                    for (var j = 0; j < brand.skus.length; ++j) {
                        var sku = brand.skus[j];
                        statisticalForecastSum += sku.forecast.value.statisticalForecast[i];
                        pmForecastSum += sku.forecast.value.pmForecast[i];
                    }
                    brand.forecast.value.statisticalForecast[i] = statisticalForecastSum;
                    brand.forecast.value.pmForecast[i] = pmForecastSum;
                }

                return synchronousEventsBus.$broadcast('brandValueForecastChanged', {
                    forecast: forecastCacheService.getForecast(),
                    brand: brand
                });
            }

            service.calculateBrandVolumeTroughtSkus = function (brand: $TSFixMe, parameters: $TSFixMe) {
                
                var s = _.find(brand.skus, function (sku: $TSFixMe) {

                    return !angular.isUndefinedOrNull(sku.forecast.volume.statisticalForecast);
                });

                brand.forecast.volume = {
                    pmForecast: [],
                    statisticalForecast: []
                };

                for (var i = 0; i < s.forecast.volume.statisticalForecast.length; i++) {

                    var pmForecastSum = 0;
                    var statisticalForecastSum = 0;
                    for (var j = 0; j < brand.skus.length; ++j) {
                        var sku = brand.skus[j];
                        statisticalForecastSum += sku.forecast.volume.statisticalForecast[i];
                        pmForecastSum += sku.forecast.volume.pmForecast[i];
                    }
                    brand.forecast.volume.statisticalForecast[i] = statisticalForecastSum;
                    brand.forecast.volume.pmForecast[i] = pmForecastSum;
                }

                return synchronousEventsBus.$broadcast('brandVolumeForecastChanged', {
                    forecast: forecastCacheService.getForecast(),
                    brand: brand
                });
            }
        }]);

    module.run(['brandCalculationService', function (service: $TSFixMe) {
        service.registerEvents();
    }]);


})(angular.module('topline.services'));